import Wrapper from "../../../layout/Wrapper";
import ClaimTrackingComponent from "../../../screens/contractControll/lifeContract/claimTracking";
import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
  title: "Life Insurance Claim Tracking",
  description: "Track life insurance claim status and progress",
};

export default function LifeInsuranceClaimTracking() {
  return (
    <Wrapper>
      <MetaComponent meta={metadata} />
      <ClaimTrackingComponent />
    </Wrapper>
  );
}
